/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Accordion from '../components/Accordion';
import AccordionFilter from '../components/AccordionFilter';
import AnniversaryOverlay from '../components/AnniversaryOverlay';
import ArticleList from '../components/ArticleList';
import ArticleListFilter from '../components/ArticleListFilter';
import BannerCarousel from '../components/BannerCarousel';
import BirthdayOverlay from '../components/BirthdayOverlay';
import BonusRewardsListing from '../components/BonusRewardsListing';
import Breadcrumb from '../components/Breadcrumb';
import Cards from '../components/Cards';
import Cart from '../components/Cart';
import CateringEvent from '../components/CateringEvent';
import Checkout from '../components/Checkout';
import CommerceCards from '../components/CommerceCards';
import ContactUsForm from '../components/ContactUsForm';
import ContentBlock from '../components/ContentBlock';
import CustomerAccount from '../components/CustomerAccount';
import CustomerFavorites from '../components/CustomerFavorites';
import CustomerOrder from '../components/CustomerOrder';
import CustomerOrders from '../components/CustomerOrders';
import CustomerSettings from '../components/CustomerSettings';
import DailyTransactionLimitReachedModal from '../components/DailyTransactionLimitReachedModal';
import EatFeaturedCards from '../components/EatFeaturedCards';
import EatMenuCards from '../components/EatMenuCards';
import EatMenuCategories from '../components/EatMenuCategories';
import EatMenuDetail from '../components/EatMenuDetail';
import EatNavigation from '../components/EatNavigation';
import EatSelectedCards from '../components/EatSelectedCards';
import ErrorHandler from '../components/ErrorHandler';
import ErrorMessage from '../components/ErrorMessage';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HolidayWizard from '../components/HolidayWizard';
import JoinRewardsModule from '../components/JoinRewardsModule';
import JustForYou from '../components/JustForYou';
import LandingPage from '../components/LandingPage';
import List from '../components/List';
import LocationBar from '../components/LocationBar';
import LocationDetail from '../components/LocationDetail';
import LocationList from '../components/LocationList';
import LocationMap from '../components/LocationMap';
import LocationSelection from '../components/LocationSelection';
import LoyaltyLogIn from '../components/LoyaltyLogIn';
import LoyaltySignUp from '../components/LoyaltySignUp';
import MealsandGiftsForm from '../components/MealsandGiftsForm';
import Media from '../components/Media';
import MemberId from '../components/MemberId';
import MenuWizard from '../components/MenuWizard';
import MobilePay from '../components/MobilePay';
import MobilePayCheckout from '../components/MobilePayCheckout';
import MobilePaySuccess from '../components/MobilePaySuccess';
import Newsletter from '../components/Newsletter';
import Newsroom from '../components/Newsroom';
import OfflineCart from '../components/OfflineCart';
import OfflineCheckout from '../components/OfflineCheckout';
import OfflineOrderDetails from '../components/OfflineOrderDetails';
import OfflineOrders from '../components/OfflineOrders';
import OfflineShop from '../components/OfflineShop';
import Onboarding from '../components/Onboarding';
import OurMenu from '../components/OurMenu';
import PausedAccountModal from '../components/PausedAccountModal';
import PegInformationModal from '../components/PegInformationModal';
import PegLevelReachedModal from '../components/PegLevelReachedModal';
import PegModule from '../components/PegModule';
import PegProgressBar from '../components/PegProgressBar';
import PegRewardListing from '../components/PegRewardListing';
import PromoContent from '../components/PromoContent';
import RecentlyViewed from '../components/RecentlyViewed';
import RetailAllCategoryCards from '../components/RetailAllCategoryCards';
import RetailCategoryCards from '../components/RetailCategoryCards';
import RetailNavigationBar from '../components/RetailNavigationBar';
import RetailProductDetail from '../components/RetailProductDetail';
import RetailProductReviews from '../components/RetailProductReviews';
import RetailProductsCardsWithFacets from '../components/RetailProductsCardsWithFacets';
import RetailSelectedProductsCards from '../components/RetailSelectedProductsCards';
import RetailSubCategoryNavLeftRail from '../components/RetailSubCategoryNavLeftRail';
import RetailTwoColumns from '../components/RetailTwoColumns';
import RetailWriteProductReviews from '../components/RetailWriteProductReviews';
import ReturnsView from '../components/ReturnsView';
import RewardsPagePausedAcc from '../components/RewardsPagePausedAcc';
import RewardsProgramModule from '../components/RewardsProgramModule';
import SavedCartNotification from '../components/SavedCartNotification';
import ScrollToTop from '../components/ScrollToTop';
import Search from '../components/Search';
import Separator from '../components/Separator';
import SweepStakes from '../components/SweepStakes';
import Tabs from '../components/Tabs';
import Timeline from '../components/Timeline';
import TitleText from '../components/TitleText';
import TwoColumns from '../components/TwoColumns';
import UpsellProductCards from '../components/UpsellProductCards';
import WaitList from '../components/WaitList';

const components = new Map();
components.set('Accordion', Accordion);
components.set('AccordionFilter', AccordionFilter);
components.set('AnniversaryOverlay', AnniversaryOverlay);
components.set('ArticleList', ArticleList);
components.set('ArticleListFilter', ArticleListFilter);
components.set('BannerCarousel', BannerCarousel);
components.set('BirthdayOverlay', BirthdayOverlay);
components.set('BonusRewardsListing', BonusRewardsListing);
components.set('Breadcrumb', Breadcrumb);
components.set('Cards', Cards);
components.set('Cart', Cart);
components.set('CateringEvent', CateringEvent);
components.set('Checkout', Checkout);
components.set('CommerceCards', CommerceCards);
components.set('ContactUsForm', ContactUsForm);
components.set('ContentBlock', ContentBlock);
components.set('CustomerAccount', CustomerAccount);
components.set('CustomerFavorites', CustomerFavorites);
components.set('CustomerOrder', CustomerOrder);
components.set('CustomerOrders', CustomerOrders);
components.set('CustomerSettings', CustomerSettings);
components.set('DailyTransactionLimitReachedModal', DailyTransactionLimitReachedModal);
components.set('EatFeaturedCards', EatFeaturedCards);
components.set('EatMenuCards', EatMenuCards);
components.set('EatMenuCategories', EatMenuCategories);
components.set('EatMenuDetail', EatMenuDetail);
components.set('EatNavigation', EatNavigation);
components.set('EatSelectedCards', EatSelectedCards);
components.set('ErrorHandler', ErrorHandler);
components.set('ErrorMessage', ErrorMessage);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('HolidayWizard', HolidayWizard);
components.set('JoinRewardsModule', JoinRewardsModule);
components.set('JustForYou', JustForYou);
components.set('LandingPage', LandingPage);
components.set('List', List);
components.set('LocationBar', LocationBar);
components.set('LocationDetail', LocationDetail);
components.set('LocationList', LocationList);
components.set('LocationMap', LocationMap);
components.set('LocationSelection', LocationSelection);
components.set('LoyaltyLogIn', LoyaltyLogIn);
components.set('LoyaltySignUp', LoyaltySignUp);
components.set('MealsandGiftsForm', MealsandGiftsForm);
components.set('Media', Media);
components.set('MemberId', MemberId);
components.set('MenuWizard', MenuWizard);
components.set('MobilePay', MobilePay);
components.set('MobilePayCheckout', MobilePayCheckout);
components.set('MobilePaySuccess', MobilePaySuccess);
components.set('Newsletter', Newsletter);
components.set('Newsroom', Newsroom);
components.set('OfflineCart', OfflineCart);
components.set('OfflineCheckout', OfflineCheckout);
components.set('OfflineOrderDetails', OfflineOrderDetails);
components.set('OfflineOrders', OfflineOrders);
components.set('OfflineShop', OfflineShop);
components.set('Onboarding', Onboarding);
components.set('OurMenu', OurMenu);
components.set('PausedAccountModal', PausedAccountModal);
components.set('PegInformationModal', PegInformationModal);
components.set('PegLevelReachedModal', PegLevelReachedModal);
components.set('PegModule', PegModule);
components.set('PegProgressBar', PegProgressBar);
components.set('PegRewardListing', PegRewardListing);
components.set('PromoContent', PromoContent);
components.set('RecentlyViewed', RecentlyViewed);
components.set('RetailAllCategoryCards', RetailAllCategoryCards);
components.set('RetailCategoryCards', RetailCategoryCards);
components.set('RetailNavigationBar', RetailNavigationBar);
components.set('RetailProductDetail', RetailProductDetail);
components.set('RetailProductReviews', RetailProductReviews);
components.set('RetailProductsCardsWithFacets', RetailProductsCardsWithFacets);
components.set('RetailSelectedProductsCards', RetailSelectedProductsCards);
components.set('RetailSubCategoryNavLeftRail', RetailSubCategoryNavLeftRail);
components.set('RetailTwoColumns', RetailTwoColumns);
components.set('RetailWriteProductReviews', RetailWriteProductReviews);
components.set('ReturnsView', ReturnsView);
components.set('RewardsPagePausedAcc', RewardsPagePausedAcc);
components.set('RewardsProgramModule', RewardsProgramModule);
components.set('SavedCartNotification', SavedCartNotification);
components.set('ScrollToTop', ScrollToTop);
components.set('Search', Search);
components.set('Separator', Separator);
components.set('SweepStakes', SweepStakes);
components.set('Tabs', Tabs);
components.set('Timeline', Timeline);
components.set('TitleText', TitleText);
components.set('TwoColumns', TwoColumns);
components.set('UpsellProductCards', UpsellProductCards);
components.set('WaitList', WaitList);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
